(() => {
  const normalise = value => String(value || '').toLowerCase().replace(/[–—-]/g, ' ').replace(/\s+/g, ' ').trim();
  const refreshGallery = (gallery, colour, featuredId) => {
    const list = gallery.querySelector('.product__media-list');
    if (!list) return;
    let colours = [];
    try { colours = JSON.parse(gallery.dataset.bfColours || '[]'); } catch {}
    colours = colours.map(value => normalise(value.name || value)).filter(Boolean).sort((a, b) => b.length - a.length);
    const selected = normalise(colour);
    const slides = [...list.querySelectorAll(':scope > [data-media-id]')];
    const active = slides.find(slide => featuredId && slide.dataset.mediaId.endsWith('-' + featuredId)) || slides.find(slide => slide.classList.contains('is-active')) || slides[0];
    const relevant = slides.filter(slide => {
      if (slide === active) return true;
      if (slide.classList.contains('product__media-item--variant')) return false;
      const alt = normalise(slide.querySelector('img')?.alt);
      const matched = colours.find(value => alt.includes(' in ' + value + ' ') || alt.endsWith(' in ' + value) || alt.startsWith(value + ' '));
      return !matched || matched === selected;
    });
    const ordered = [active, ...relevant.filter(slide => slide !== active)].filter(Boolean).slice(0, 6);
    const ids = new Set(ordered.map(slide => slide.dataset.mediaId));
    slides.forEach(slide => { slide.dataset.bfHidden = String(!ids.has(slide.dataset.mediaId)); });
    gallery.querySelectorAll('.thumbnail-list__item[data-target]').forEach(item => { item.dataset.bfHidden = String(!ids.has(item.dataset.target)); });
    const total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = String(ordered.length);
    gallery.querySelector('product-gallery')?.initPages?.();
    gallery.querySelector('.thumbnail-slider')?.initPages?.();
  };
  const initialise = () => {
    document.querySelectorAll('[data-bf-gallery]').forEach(gallery => refreshGallery(gallery, gallery.dataset.bfSelectedColour));
    document.addEventListener('variant:change', event => {
      const variant = event.detail?.variant;
      if (!variant?.featured_media) return;
      document.querySelectorAll('[data-bf-gallery]').forEach(gallery => {
        if (!gallery.querySelector('[data-media-id$="-' + variant.featured_media.id + '"]')) return;
        refreshGallery(gallery, variant.options[Number(gallery.dataset.bfColourIndex || 0)], variant.featured_media.id);
      });
    });
    document.addEventListener('click', event => {
      if (!event.target.closest('a[href="#bf-product-fit"]')) return;
      const fit = document.getElementById('bf-product-fit');
      if (fit) fit.open = true;
    });
    let queued = false;
    const tidyLikes = () => {
      queued = false;
      document.querySelectorAll('.bf-product-actions--detail .likely-click-eliment').forEach(button => {
        const count = button.querySelector('.likely-count-label');
        if (count && /^0(?:\s|$)/.test(count.textContent.trim())) {
          count.hidden = true;
          const label = button.querySelector('.likely-text');
          const text = document.body.dataset.bfSave || 'Save';
          if (label && label.textContent !== text) label.textContent = text;
          if (button.getAttribute('aria-label') !== text) button.setAttribute('aria-label', text);
        }
      });
    };
    tidyLikes();
    new MutationObserver(changes => {
      const relevant = changes.some(change => change.target.nodeType === 1 && (change.target.closest?.('.bf-product-actions--detail') || [...change.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('.likely-click-eliment') || node.querySelector?.('.likely-click-eliment')))));
      if (!relevant || queued) return;
      queued = true;
      requestAnimationFrame(tidyLikes);
    }).observe(document.body, {childList:true, subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once:true});
  else initialise();
})();
